<section class="topbar-padding-top container container-size-xs section-outset-y">
  @if ((prefix + '-titel' | fromDictionary : false) || title) {
    <h1
      class="h1"
      [ngClass]="(prefix + '-intro' | fromDictionary : false) ? 'mb-1' : 'mb-4'"
      >
      {{ title || (prefix + '-titel' | fromDictionary) }}
    </h1>
  }

  @if ((prefix + '-intro' | fromDictionary : false) || intro) {
    <p class="type-body-sm mb-4">
      {{ intro || (prefix + '-intro' | fromDictionary) }}
    </p>
  }

  <ng-content select="[form]"></ng-content>
  <ng-content select="[footer]"></ng-content>
</section>
